import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [organization, setOrganization] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setOrganization(data.organization || null);
      return data.user;
    } catch (e) {
      setUser(null);
      setOrganization(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // If returning from OAuth callback, skip /me check — AuthCallback will handle it
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    refresh();
  }, [refresh]);

  const loginDemo = async (demoUserId) => {
    const { data } = await api.post("/auth/session", { demo_user_id: demoUserId });
    if (data?.session_token) localStorage.setItem("ths_session_token", data.session_token);
    await refresh();
    return data.user;
  };

  const loginPassword = async (email, password, organization_id) => {
    const { data } = await api.post("/auth/login", { email, password, organization_id });
    if (data?.session_token) localStorage.setItem("ths_session_token", data.session_token);
    await refresh();
    return data.user;
  };

  const registerPassword = async ({ email, password, name }) => {
    const { data } = await api.post("/auth/register", { email, password, name });
    if (data?.session_token) localStorage.setItem("ths_session_token", data.session_token);
    await refresh();
    return data.user;
  };

  const loginGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("ths_session_token");
    setUser(null);
    setOrganization(null);
    window.location.href = "/login";
  };

  return (
    <AuthCtx.Provider value={{ user, organization, loading, refresh, loginDemo, loginGoogle, loginPassword, registerPassword, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
